export default __webpack_public_path__ + "static/media/galaxy.dcbba60c.jfif";